// extracted by mini-css-extract-plugin
export default {"page":"More_page__hU1kS","form":"More_form__Cx0aM","thankYou":"More_thankYou__RZ1C0"};